<template>
  <div id="cart">
    <HeaderCart />
    <Cart />
    <Footer />
  </div>
</template>

<script>
import HeaderCart from "@/components/checkout/cart/HeaderCart";
import Cart from "@/components/checkout/cart/Cart";
import Footer from "@/components/template/Footer";

export default {
  data() {
    return {
      linkDaPagina: null,
    };
  },
  
  async created() {
    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: "Carrinho | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "No Carrinho de Compras Leveros Integra você encontra os produtos que foram adicionados ao seu carrinho.",
        },
        { name: "robots", content: "noindex,nofollow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Carrinho | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "No Carrinho de Compras Leveros Integra você encontra os produtos que foram adicionados ao seu carrinho.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  components: {
    HeaderCart,
    Cart,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
#cart {
  background: #f0f0f0;

  @media (min-width: 769px) {
    background: #fff;
  }
}
</style>